import { createApp } from "vue";
import router from "./router";
import App from "./App.vue";
import Vant from "vant";
import "vant/lib/index.css";
import i18n from "@/language/index.js";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import VConsole from "vconsole";
import { onWindowResize } from "@/utils/help";

import "./style/global.less";
import "./style/carousel.css";
import "./style/tailwind.less";

createApp(App).use(router).use(Antd).use(Vant).use(i18n).mount("#app");
if (process.env.NODE_ENV !== "production") {
  new VConsole();
}

// 窗口大小变化 自动刷新
onWindowResize(({ width, oldWidth }) => {
  // 设备变化的时候再刷新
  if (
    (oldWidth > 1200 && width <= 1200) ||
    (oldWidth <= 1200 && width > 1200)
  ) {
    window.location.reload();
  }
});
